<template>
<div class="chapter">
<div class="inner_page">
<div class="covser" id="cover"><img alt="image" height="100%" src="images/cover.jpg" width="100%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split0.vue?0b2a4b84